<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody>
            <CForm
                ref="formViewProviderIntegration"
                @submit="submitForm($event, 'viewProviderIntegration')"
            >
                <CTabs variant="tabs" :active-tab="0">
                    <!--  Tab General -->
                    <CTab :title="$t('general')">
                        <CCard>
                            <CCardBody>
                                <CInput
                                    :isValid="
                                        checkIfFormValid({
                                            formName: 'viewProviderIntegration',
                                            fieldName: 'name',
                                        })
                                    "
                                    :placeholder="$t('enter_the_name')"
                                    :value.sync="
                                        $v.forms.viewProviderIntegration.name
                                            .$model
                                    "
                                    :label="$t('name')"
                                    v-bind="defaultInputConfig"
                                />
                                <SelectAsync
                                    :value.sync="
                                        forms.viewProviderIntegration
                                            .provider_uuid
                                    "
                                    :placeholder="$t('select_an_option')"
                                    size="sm"
                                    :label="$t('input')"
                                    optionsValue="uuid"
                                    optionsLabel="name"
                                    endpoint="/input.api/providers/list"
                                    typeSelect="CSelect"
                                    v-bind="defaultInputConfig"
                                />
                                <SelectAsync
                                    v-if="
                                        forms.viewProviderIntegration
                                            .provider_uuid
                                    "
                                    :value.sync="
                                        forms.viewProviderIntegration.form_uuid
                                    "
                                    :placeholder="$t('select_an_option')"
                                    size="sm"
                                    :label="$t('form')"
                                    optionsValue="uuid"
                                    optionsLabel="name"
                                    :endpoint="`/input.api/providers/${forms.viewProviderIntegration.provider_uuid}/forms`"
                                    typeSelect="CSelect"
                                    v-bind="defaultInputConfig"
                                />
                                <SelectFormSponsors
                                    v-if="
                                        forms.viewProviderIntegration.form_uuid
                                    "
                                    :placeholder="$t('search_list')"
                                    size="sm"
                                    :value.sync="
                                        forms.viewProviderIntegration.settings
                                            .sponsors
                                    "
                                    :label="$t('sponsors')"
                                    optionsValue="CampaignId"
                                    optionsLabel="CampaignName"
                                    :form="
                                        forms.viewProviderIntegration.form_uuid
                                    "
                                    v-bind="defaultInputConfig"
                                />
                                <SelectAsync
                                    :placeholder="$t('select_a_plugin')"
                                    size="sm"
                                    :label="$t('plugin')"
                                    :invalidFeedback="$t('plugin_is_required')"
                                    :optionsValue="'uuid'"
                                    :optionsLabel="'name'"
                                    :value.sync="
                                        $v.forms.viewProviderIntegration
                                            .plugin_marketing_credentials_uuid
                                            .$model
                                    "
                                    endpoint="/connector.api/getPluginsCredentials"
                                    v-bind="defaultInputConfig"
                                />
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave
                                    color="success"
                                    @click="
                                        executeSubmitForm(
                                            'formViewProviderIntegration'
                                        )
                                    "
                                    :disabled="
                                        forms.viewProviderIntegration._loading
                                    "
                                />
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardFooter>
                        </CCard>
                    </CTab>
                    <CTab :title="$t('settings')">
                        <CCard>
                            <CCardBody>
                                <CRow>
                                    <CCol md="12" sm="12">
                                        <h5>
                                            {{ $t("Fixed fields") }}
                                        </h5>
                                        <p class="mb-0">
                                            {{
                                                $t(
                                                    "You can create fixed fields for your integration"
                                                )
                                            }}.
                                        </p>
                                        <TableFixedFields
                                            :value.sync="
                                                forms.viewProviderIntegration
                                                    .settings.fixedFields
                                            "
                                        />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol md="12" sm="12">
                                        <h5>
                                            {{ $t("field_mapping") }}
                                        </h5>
                                        <p class="mb-0">
                                            {{
                                                $t(
                                                    "You can mapping the fields"
                                                )
                                            }}.
                                        </p>
                                        <TableFieldMapping
                                            :value.sync="
                                                forms.viewProviderIntegration
                                                    .settings.fieldMapping
                                            "
                                        />
                                    </CCol>
                                </CRow>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave
                                    color="success"
                                    @click="
                                        executeSubmitForm(
                                            'formViewProviderIntegration'
                                        )
                                    "
                                    :disabled="
                                        forms.viewProviderIntegration._loading
                                    "
                                />
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardFooter>
                        </CCard>
                    </CTab>
                </CTabs>
            </CForm>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import SelectAsync from "£lement/SelectAsync";
import ButtonSave from "~/components/ButtonSave.vue";
import TableFixedFields from "~/components/TableFixedFields.vue";
import TableFieldMapping from "~/components/TableFieldMapping.vue";
import SelectFormSponsors from "£lement/SelectFormSponsors";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";
import formMixin from "~/mixins/form";

/** Others */
import { cilTrash, cilArrowBottom, cilArrowTop, cilPlus } from "@coreui/icons";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
    name: "InputsIntegrationsViewPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, formMixin, validationMixin],

    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPlus,
    },

    components: {
        ButtonBack,
        SelectAsync,
        ButtonSave,
        TableFixedFields,
        TableFieldMapping,
        SelectFormSponsors,
        // ViewGeneralTab,
    },

    data() {
        return {
            forms: {
                viewProviderIntegration: {
                    // id: null,
                    // uuid: null,
                    name: null,
                    provider_uuid: null,
                    form_uuid: null,
                    plugin_marketing_credentials_uuid: null,
                    // action_id: null,
                    settings: {},
                    _loading: false,
                    _matchResponse: "_items",
                },
            },

            formInfo: {
                id: null,
            },

            providerInfo: {
                id: null,
            },
        };
    },

    validations: {
        forms: {
            viewProviderIntegration: {
                name: {
                    required,
                },
                plugin_marketing_credentials_uuid: {
                    required,
                },
            },
        },
    },
    computed: {
        ...mapGetters({
            storePlugins: "global/plugins",
            storePluginIntegrations: "global/pluginIntegrations",
            storeTriggerEvents: "global/triggerEvents",
        }),
        viewType: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.params.uuid;
        },
        pluginIntegration() {
            let find = this.storePluginIntegrations.find(
                (pluginIntegration) =>
                    pluginIntegration.id ==
                    this.forms.viewProviderIntegration
                        .plugin_marketing_credentials_uuid
            );
            return find;
        },
        plugin() {
            return this.storePlugins.find(
                (plugin) => plugin.uuid == this.pluginIntegration.driver_id
            );
        },
        pluginActionsAsOptions() {
            if (this.plugin) {
                return this.plugin.actions.map((action) => {
                    return {
                        value: action.id,
                        label: action.name,
                    };
                });
            }
            return [];
        },
        pluginActionSelected() {
            if (this.forms.viewProviderIntegration.action_id && this.plugin) {
                let find = this.plugin.actions.find((action) => {
                    return (
                        this.forms.viewProviderIntegration.action_id ==
                        action.id
                    );
                });
                return find;
            }
            return null;
        },
        pluginActionFields() {
            if (this.pluginActionSelected) {
                return this.pluginActionSelected.fields;
            }
            return [];
        },
    },
    watch: {
        "forms.viewProviderIntegration._loading": function (val) {
            this.updatePageLoading(val);
        },
        "providerInfo.id": async function (val) {
            if (val) {
                await this.loadProviderInfo();
            }
            // await this.loadListForms();
        },
        "formInfo.id": async function (val) {
            if (val) {
                await this.loadFormInfo();
                this.$set(
                    this.forms.viewProviderIntegration.settings,
                    "xFormToken",
                    this.formInfo["api_key"]
                );
            }
        },
    },
    methods: {
        async submitForm(e, formName) {
            e.preventDefault();
            if (this.viewType == "edit") {
                await this.sendForm({
                    formName,
                    url: "/provider-integrations/" + this.uuid,
                    method: "PUT",
                });
            } else {
                await this.sendForm({
                    formName,
                    url: "/provider-integrations",
                });
            }

            this.$router.push({ name: "integrations" });
        },
        async loadProviderInfo() {
            let provider = await this.fetcher({
                url: `/provider/${this.providerInfo.id}`,
            });
            this.providerInfo = {
                ...provider,
                id: provider.id.toString(),
            };
            let providerFields = await this.fetcher({
                url: "/provider_field",
                query: {
                    query: {
                        where: {
                            Provider: {
                                uuid: this.providerInfo.uuid,
                            },
                        },
                    },
                },
            });
            providerFields = providerFields.map((item) => {
                let findField = this.storeGlobalFieldsAdvance.find((field) => {
                    return field.id == item.field_id;
                });
                if (findField)
                    return {
                        ...item,
                        name: findField.name,
                    };
                return item;
            });

            this.providerInfo = {
                ...this.providerInfo,
                fields: providerFields,
            };
        },

        async loadFormInfo() {
            let info = await this.fetcher({
                url: "/form/" + this.formInfo.id,
            });
            this.formInfo = info;
        },

        async loadPlugins() {
            if (this.storePlugins.length == 0) {
                let plugins = await this.fetcher({
                    url: "/connector.api/getPlugins",
                });

                this.$store.dispatch("global/savePlugins", {
                    plugins: plugins._items,
                });
            }
        },
        async loadPluginIntegrations() {
            if (this.storePluginIntegrations.length == 0) {
                let pluginIntegrations = await this.fetcher({
                    url: '/connector.api/getPluginsCredentials?query=""',
                });

                this.$store.dispatch("global/savePluginIntegrations", {
                    pluginIntegrations: pluginIntegrations._items,
                });
            }
        },
    },
    async mounted() {
        await this.loadPlugins();
        await this.loadPluginIntegrations();
        if (this.viewType == "edit") {
            await this.updateForm({
                formName: "viewProviderIntegration",
                url: "provider-integrations/" + this.uuid,
                adapterData: (data) => {
                    if (data.settings) {
                        data.settings = JSON.parse(data.settings);
                    }
                    return data;
                },
            });
        }
        this.updatePageLoading(false);
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
</style>
